<template>
  <div class="box12">
    <pageTitle title="精品课程推荐" titleColor="#0D004D" />
    <div class="scrollBox">
      <div class="classBox">
        <img
          v-for="(item, index) in list"
          :key="index"
          :src="item.img"
          alt=""
          @click="openDetail(item)"
        />
        <div class="seat"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/media/box16/3.jpg"),
          href: "https://www.boxuegu.com/course/detail-5628.html",
        },

        {
          img: require("../../../assets/coursePage/media/box16/2.jpg"),
          href: "https://www.boxuegu.com/course/detail-5629.html ",
        },
        {
          img: require("../../../assets/coursePage/media/box16/1.jpg"),
          href: "https://www.boxuegu.com/course/detail-5630.html",
        },
      ],
    };
  },
  methods: {
    openDetail(item) {
      window.open(item.href);
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/media/box16/bgc.png") no-repeat;
  background-size: cover;
  .scrollBox::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scrollBox {
    width: 750px;
    overflow: scroll;
  }
  .classBox {
    display: flex;
    padding-left: 32px;
    margin-top: 48px;
    img {
      width: 316px;
      height: 192px;
      border-radius: 12px;
      margin-right: 24px;
    }
    .seat {
      width: 32px;
      flex-shrink: 0;
    }
    img:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>
